








































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import CustomerType from "@/store/entities/customer-types/customer-type";
Vue.use(require("vue-moment"));

@Component
export default class CreateCustomer extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  customerType: CustomerType = new CustomerType();
  pricingTerms = [];
  spinShow: boolean = false;

  isClient() {
    return this.$store.state.session.client != null;
  }
  get client() {
    return this.$store.state.session.client;
  }

  async getPricingTerms() {
    await this.$store
      .dispatch({
        type: "productPricing/getPricingTerms",
        data: { hasAllItem: false },
      })
      .then((result) => {
        this.pricingTerms = result;
        this.customerType.pricingTermCode =
          this.pricingTerms.length === 0 ? "" : this.pricingTerms[0].id;
      });
  }
  async save() {
    this.$Modal.confirm({
      title: this.L("Tips"),
      content: this.L("Confirm.CreateCustomerType"),
      okText: this.L("Yes"),
      cancelText: this.L("No"),
      onOk: async () => {
        this.spinShow = true;
        try {
          await this.$store
            .dispatch({
              type: "customerType/create",
              data: {
                id: this.customerType.id,
                name: this.customerType.name,
                pricingTermCode: this.customerType.pricingTermCode,
              },
            })
            .then((result) => {
              Util.showSuccessMsg(this, "Success.CreateCustomerType");
              this.reset();
              this.onGoBack();
            });
          this.spinShow = false;
        } catch (error) {
          this.spinShow = false;
        }
      },
    });
  }
  onGoBack() {
    this.$root.$router.push({ name: "customertype" });
  }

  reset() {
    this.spinShow = false;
    this.customerType = new CustomerType();
    this.pricingTerms = [];
  }

  async created() {
    this.spinShow = true;
    try {
      await this.getPricingTerms();
      this.spinShow = false;
    } catch (error) {
      this.spinShow = false;
    }
  }

  customerTypeRule = {
    id: [
      {
        required: true,
        message: this.L("Error.RequiredField", undefined, this.L("Code")),
        trigger: "blur",
      },
    ],
    name: [
      {
        required: true,
        message: this.L("Error.RequiredField", undefined, this.L("Name")),
        trigger: "blur",
      },
    ],
    pricingTermCode: [
      {
        required: true,
        message: this.L(
          "Error.RequiredField",
          undefined,
          this.L("PricingTerm")
        ),
        trigger: "blur",
      },
    ],
  };
}
